import { render, staticRenderFns } from "./CheckboxBig.vue?vue&type=template&id=063c2feb&scoped=true"
import script from "./CheckboxBig.vue?vue&type=script&lang=js"
export * from "./CheckboxBig.vue?vue&type=script&lang=js"
import style0 from "./CheckboxBig.vue?vue&type=style&index=0&id=063c2feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c2feb",
  null
  
)

export default component.exports